







































































































































import { Component, Prop, Vue, PropSync } from 'vue-property-decorator';
import { SensorsApi, Sensor } from '../../api';
import TitleMixin from '@/mixins/title-mixin';
import { reportUnhandledError } from 'rxjs/dist/types/internal/util/reportUnhandledError';

@Component({
	components: {},
	mixins: [TitleMixin],
})
export default class SensorRawData extends Vue {
	public currentPage = 1;
	public perPage = 100;
	public totalRows = 0;
	public filter = '';
	public rawData = [];
	public sortKey = '';
	public key = '';
	public active = '';
	public loading = false;
	@Prop(Number) public sensorId?: number;
	public sensor: any | null = null;

	public rawDataFields: any[] | null = [
		{ key: 'receivedTime', label: 'Parsed SortKey Time', sortable: true },
		{ key: 'data', label: 'Data' },
		{ key: 'topic', label: 'Topic' },
	];
	public form = { filter: '' };
	private api: SensorsApi;

	public async load() {
		this.loading = true;
		try {
			const { data } = await new SensorsApi().getSensorById(this.sensorId, 10);
			this.sensor = data;
			this.reload(null, null, false);
		} catch (e) {
			console.log(e);
			this.sensor = null;
		} finally {
			this.loading = false;
		}
	}

	public async reload(key: string, sortKey: string, prev = false) {
		const sensorId = this.sensorId;
		try {
			const api = new SensorsApi();
			const response = await api.getSensorRawData(sensorId, 1000, this.sortKey, this.key);

			response.data.forEach(obj => (obj.receivedTime = parseInt(obj.sortKey.split('/')[1], 10)));
			this.rawData = this.rawData.concat(response.data);
			this.sortKey = this.rawData[this.rawData.length - 1].sortKey;
			this.key = this.rawData[this.rawData.length - 1].key;
			this.totalRows = this.rawData.length;
			this.rawData.sort((a, b) => (a.receivedTime < b.receivedTime && 1) || -1);
		} catch (e) {
			console.log(e);
		}
	}

	public onFiltered(filteredItems) {
		// Trigger pagination to update the number of buttons/pages due to filtering
		this.totalRows = filteredItems.length;
	}

	public created() {
		this.load();
	}
}
